import BaseService from '../../base/base_service';
import IOrbitComponentRenderService from './orbit_component_render_service_interface';
import {IPartyJackpotInGameWidgetComponentProps} from '../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/party-jackpot-ingame-widget.component-props';
import {
    IGermanyResponsibleGamingButtonOptions,
    IOrbitComponentInSdk,
    IOrbitComponentToSdkAdapterService, IOrbitDialogInSdk
} from '../../../../common/interfaces/orbit-component-to-sdk-adapter/orbit-component-to-sdk-adapter.service.interface';
import { ITimeSpentReminderOptions } from '../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/time-spent-reminder-options';
import {IShowPartyJackpotWelcomePopupOptions} from '../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/show-party-jackpot-welcome-popup-options';
import {IStatePopupOptions} from "../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/state-popup.component-props";
import Event from "../../utils/event";
import {SYSTEM_EVENTS} from "../../events/events";

interface OrbitComponentRendererServiceParams {
    getOrbitComponentToSdkAdapter: () => IOrbitComponentToSdkAdapterService;
}

export default class OrbitComponentRenderService extends BaseService implements IOrbitComponentRenderService {
    static CLASS = 'OrbitComponentRenderService';

    init(params: OrbitComponentRendererServiceParams) {
        super.init(params);
        this._getOrbitComponentToSdkAdapter = params.getOrbitComponentToSdkAdapter;
    }

    private _getOrbitComponentToSdkAdapter: () => IOrbitComponentToSdkAdapterService;

    renderPartyJackpotInGameWidget(element: HTMLElement, props: IPartyJackpotInGameWidgetComponentProps): IOrbitComponentInSdk {
        return this._getOrbitComponentToSdkAdapter().renderPartyJackpotInGameWidget(element, props);
    }

    renderGermanyResponsibleGamingButtons(element: HTMLElement, options?:IGermanyResponsibleGamingButtonOptions): IOrbitComponentInSdk{
        return this._getOrbitComponentToSdkAdapter().renderGermanyResponsibleGamingButtons(element, options);
    }

    showPartyJackpotWelcomePopup(props: IShowPartyJackpotWelcomePopupOptions): IOrbitDialogInSdk {
        return this._getOrbitComponentToSdkAdapter().showPartyJackpotWelcomePopup(props);
    }

    showLocationPopup(props: IStatePopupOptions) {
        Event.fire(SYSTEM_EVENTS.LOCATION_POPUP_OPEN);
        props.onMessageClosed = ()=> {
            props.onMessageClosed && props.onMessageClosed();
            Event.fire(SYSTEM_EVENTS.LOCATION_POPUP_CLOSED);

        };

        return this._getOrbitComponentToSdkAdapter().showLocationPopup(props);
    }

    showTimeSpentReminder(options: ITimeSpentReminderOptions): IOrbitDialogInSdk {
        return this._getOrbitComponentToSdkAdapter().showTimeSpentReminder(options);
    }
}